import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="app"
export default class extends Controller {
  initialize() {
  }
}
